import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { FormGroup, Label, Input } from 'reactstrap'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { api } from '../../utils'

const FeedbackFormModal = ({ show, onHide, allowedServices }) => {
  const [tool, setTool] = useState(null)
  const [feedbackType, setFeedbackType] = useState('')
  const [corpo, setCorpo] = useState('')
  const [linkDettaglio, setLinkDettaglio] = useState('')
  const [esempio, setEsempio] = useState('')
  const [images, setImages] = useState([])
  const [loading, setLoading] = useState(false)

  const toolOptions = [...new Set((allowedServices || []).map((s) => s.name))].map((name) => ({
    value: name,
    label: name,
  }))

  const resetForm = () => {
    setTool(null)
    setFeedbackType('')
    setCorpo('')
    setLinkDettaglio('')
    setEsempio('')
    setImages([])
  }

  const handleClose = () => {
    resetForm()
    onHide()
  }

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files)
    setImages((prev) => [...prev, ...files])
    // Reset the input so the same file can be re-selected if removed
    e.target.value = ''
  }

  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index))
  }

  const handleSubmit = async () => {
    if (!tool || !feedbackType || !corpo.trim()) {
      toast.error('Compila i campi obbligatori: Tool, Tipo feedback, Descrizione')
      return
    }

    const formData = new FormData()
    formData.append('tool', tool.value)
    formData.append('utilita_segnalazione', feedbackType)
    formData.append('corpo_segnalazione', corpo)
    formData.append('link_dettaglio', linkDettaglio)
    formData.append('esempio', esempio)
    images.forEach((file) => {
      formData.append('images', file)
    })

    setLoading(true)
    try {
      await api.post('feedback', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      toast.success('Feedback inviato con successo')
      handleClose()
    } catch (err) {
      toast.error("Errore durante l'invio del feedback")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">Inserisci Feedback</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-4 text-center">
          I feedback inseriti verranno registrati nel seguente {' '}
          <a
            href="https://docs.google.com/spreadsheets/d/1iDGnIqBFEmIw9qB0fx57XZQ0BQxDUn9BG7fAPhKV8F0/edit?gid=0#gid=0"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Sheet
          </a>

        </p>
        <FormGroup>
          <Label>Tool *</Label>
          <Select
            value={tool}
            onChange={setTool}
            options={toolOptions}
            placeholder="Seleziona un tool..."
            isClearable
          />
        </FormGroup>

        <FormGroup>
          <Label>Tipo feedback *</Label>
          <div className="d-flex">
            <Button
              variant={feedbackType === 'POS' ? 'success' : 'outline-success'}
              className="mr-2 flex-fill"
              onClick={() => setFeedbackType('POS')}
            >
              Positivo
            </Button>
            <Button
              variant={feedbackType === 'NEG' ? 'danger' : 'outline-danger'}
              className="flex-fill"
              onClick={() => setFeedbackType('NEG')}
            >
              Negativo
            </Button>
          </div>
        </FormGroup>

        <FormGroup>
          <Label>Descrizione *</Label>
          <Input
            type="textarea"
            value={corpo}
            onChange={(e) => setCorpo(e.target.value)}
            rows={4}
            placeholder="Descrivi il feedback..."
          />
        </FormGroup>

        <FormGroup>
          <Label>Link dettaglio</Label>
          <Input
            type="text"
            value={linkDettaglio}
            onChange={(e) => setLinkDettaglio(e.target.value)}
            placeholder="https://..."
          />
        </FormGroup>

        <FormGroup>
          <Label>Esempio</Label>
          <Input
            type="textarea"
            value={esempio}
            onChange={(e) => setEsempio(e.target.value)}
            rows={3}
            placeholder="Inserisci un esempio..."
          />
        </FormGroup>

        <FormGroup>
          <Label>Immagini</Label>
          <Input type="file" accept="image/*" multiple onChange={handleImageChange} />
          {images.length > 0 && (
            <div className="d-flex flex-wrap mt-2">
              {images.map((file, idx) => (
                <div key={idx} className="position-relative mr-2 mb-2">
                  <img
                    src={URL.createObjectURL(file)}
                    alt={file.name}
                    style={{
                      width: 80,
                      height: 80,
                      objectFit: 'cover',
                      borderRadius: 4,
                    }}
                  />
                  <button
                    type="button"
                    className="btn btn-sm btn-danger position-absolute"
                    style={{ top: -8, right: -8, padding: '0 5px', lineHeight: '1.4' }}
                    onClick={() => removeImage(idx)}
                  >
                    x
                  </button>
                </div>
              ))}
            </div>
          )}
        </FormGroup>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Invio in corso...' : 'Invia'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default FeedbackFormModal
